export default __webpack_public_path__ + "static/media/ir_vid.322376d3.mp4";